import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { copyToClipboard } from '../utils/copyToClipboard';
import { useState } from 'react';

export default function OutputPanel({ output }) {
  const [copiedText, setCopiedText] = useState(false);
  const [copiedJson, setCopiedJson] = useState(false);

  const copy = async (text, setFlag) => {
    await copyToClipboard(text);
    setFlag(true);
    setTimeout(() => setFlag(false), 2000);
  };

  if (!output.text) return null;

  return (
    <div className="mt-12 space-y-8">
      {/* Text Prompt */}
      <div>
        <h3 className="text-xl font-semibold mb-3 dark:text-gray-100">Text Prompt</h3>
        <div className="relative">
          <textarea
            readOnly
            value={output.text}
            className="
              w-full h-32 p-4 rounded-lg
              bg-[#0f380f] text-[#00ff00] font-mono text-sm
              resize-none border border-[#0f380f] shadow-inner
            "
          />
          <button
            onClick={() => copy(output.text, setCopiedText)}
            className="absolute top-2 right-2 p-2 bg-[#e0ffe0] hover:bg-[#d0ffd0] rounded-lg transition"
            title={copiedText ? "Copied!" : "Copy to clipboard"}
          >
            <FontAwesomeIcon
              icon={`fas fa-${copiedText ? 'check' : 'clipboard'}`}
              className="text-[#006400]"
            />
          </button>
        </div>
      </div>

      {/* JSON Prompt */}
      <div>
        <h3 className="text-xl font-semibold mb-3 dark:text-gray-100">JSON Prompt</h3>
        <div className="relative">
          <pre
            className="
              p-4 h-64 rounded-lg overflow-auto
              bg-[#0f380f] text-[#00ff00] font-mono text-sm
              border border-[#c0ffc0] shadow-inner
            "
          >
            {output.json}
          </pre>
          <button
            onClick={() => copy(output.json, setCopiedJson)}
            className="absolute top-2 right-2 p-2 bg-[#e0ffe0] hover:bg-[#d0ffd0] rounded-lg transition"
            title={copiedJson ? "Copied!" : "Copy to clipboard"}
          >
            <FontAwesomeIcon
              icon={`fas fa-${copiedJson ? 'check' : 'clipboard'}`}
              className="text-[#006400]"
            />
          </button>
        </div>
      </div>
    </div>
  );
}
